
import axios from 'axios'
import router from '../router'


// 创建一个axios实例
const ajax = axios.create({
    // baseURL: 'https://test.3ddang.com'
    baseURL:process.env.baseUrl
})

/**
 * 拦截器 -- 请求拦截--request，响应拦截--response
 */
ajax.interceptors.request.use(config => {

    // 当前请求地址，不再用户拦截权限范围以内，直接发送请求
    // const urls = [
    //     "/user/validate/code",
    //     "/user/app/login"
    // ]
    // if (urls.includes(config.url)) {
    //     return config
    // }

    /** 如果需要判断用户权限，那么要获取token */
    let token = localStorage.getItem('token')
    // if (!token) return Promise.reject({code: 900, message: '用户没有访问此接口的权限'})

    /** 有token，就应该把token添加到请求头上 */
    config.headers.a_token = token
    return config
})
ajax.interceptors.response.use(function(responseObject) {

    let { data } = responseObject
    if (data.code === 1003) {
        // 提示用户登录已经时效--token没有
        alert('用户的token已经失效，请重新登录')
            router.push('/login')
        return Promise.reject({code: 999, message: '用户需要重新登录'})
    } else {
        return responseObject
    }
})

/**
 * 封装的ajax请求
 * @param {{url: string, data: any, params: {} | undefined, method: "POST" | "GET" | "PUT" | "DELETE"}} req 请求对象
 * @returns Promise
 */
export default function ajaxFunc(req) {
    var getKey = sessionStorage.getItem("myKey");
        getKey || (getKey = 1);
    if (req.data) {
        req.data.c = getKey;
    }else if (req.params) {
      req.params.c = getKey;
    }
    return new Promise(resolve => {
        ajax.request({
            url: req.url,
            method: req.method || 'post',
            headers: req.headers||{},
            data: req.data || {},
            params: req.params || {},
        }).then(({ data }) => {
            resolve(data)
        }).catch(e => {
            resolve(e)
        })
    })
}



// WEBPACK FOOTER //
// ./src/apis/ajax.js